import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/panels.css */
  & {
    display: flex;
    flex-wrap: wrap;
    flex-flow: column;
    width: 100%;
    padding: ${({ noWrapper }) => (noWrapper ? '' : '15px 0')};
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  }
  & .row {
    flex-flow: row;
    justify-content: space-between;
    margin: 0;
    padding: 0 15px;
    display: flex;
    align-items: center;
  }
  & .row.subtitle {
    font-weight: 600;
    font-size: 0.75rem;
    margin: 0 0 8px 0;
    text-transform: uppercase;
  }
  & .subtitle {
    font-weight: 600;
    font-size: 0.75rem;
    white-space: nowrap;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  & .subtitle {
    align-items: flex-start;
    justify-content: flex-start;
  }
`

const developerCSS = css``

export const SectionCSS = styled.section`
  ${designerCSS}
  ${developerCSS}
`
